<template>
  <div class="row mb--small">
    <visitors></visitors>
    <div class="col-sm-6 col-xs-12">
      <div class="mb--small">
        <average-time></average-time>
      </div>
      <conversions></conversions>
    </div>
  </div>
</template>

<script>
import Visitors from '@/screens/Metrics/components/boxes/Visitors';
import AverageTime from '@/screens/Metrics/components/boxes/AverageTime';
import Conversions from '@/screens/Metrics/components/boxes/Conversions';

export default {
  data() {
    return { pageIdentifier: this.$route.params.pageIdentifier };
  },
  components: {
    Visitors,
    AverageTime,
    Conversions,
  },
};
</script>



// WEBPACK FOOTER //
// src/screens/Metrics/components/metrics/Metrics.vue